import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { CdwProgressBarComponent } from './cdw-progress-bar/cdw-progress-bar.component';

@NgModule({
  imports: [CommonModule, MaterialLibraryModule],
  declarations: [CdwProgressBarComponent],
  exports: [CdwProgressBarComponent],
})
export class CdwProgressBarModule {}
